import { useExperiment } from 'utils/experiments'
import useResponsiveDesign from './useResponsiveDesign'
import { useCurrentWorkspace } from './useCurrentWorkspace'
import { useMemo } from 'react'

export const useAPMobileWeb = (): boolean => {
  const { isMobile, isIOSNative } = useResponsiveDesign()

  const workspace = useCurrentWorkspace()
  const isAutopilot = useMemo(() => !!workspace?.is_virtual_marketer, [workspace])

  const variant = useExperiment('mobile_calendar_access')
  const isAllowed = useMemo(() => variant === 'allow', [variant])

  const isAPMobileWeb = useMemo(() => {
    const isStrictlyMobile = isMobile && !isIOSNative
    return isStrictlyMobile && isAllowed && isAutopilot
  }, [isAllowed, isAutopilot, isIOSNative, isMobile])

  return isAPMobileWeb
}
